import { HelpCircle } from 'lucide-react';
import { createWebRegistration } from '@reflex/plugin-api/create-web-registration';

// help plugin has no routes with componentPath — uses hash links only.
// HelpPopover is loaded by the shell directly, not via manifest routing.
export default createWebRegistration({
  components: {
    '@reflex/plugin-help/web/HelpPopover': () => import('./HelpPopover'),
  },
  icons: { HelpCircle },
});
